import { render, staticRenderFns } from "./AreaSalesCreate.vue?vue&type=template&id=4cf388d4"
import script from "./AreaSalesCreate.vue?vue&type=script&lang=js"
export * from "./AreaSalesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports